export const formFields = {
    accountId: {
        key: 'accountId',
        label: 'Account Id',
        labelLayout: 'col-sm-5 text-left',
        placeholder: '',
        required: true,
        requiredMessage: 'This field is required.',
        displayLayout: 'col-md-12',
        tooltip: '<div>Account Id</div>',
        valueKey: 'key',
        textKey: 'value'
    }
};

export const platformConfig = {
    google: "Google Ads",
    beki: "beki",
    ion: "ION",
    meta: "Meta",
    dv360: "DV360",
    tiktok: "TikTok",
};